import { render, staticRenderFns } from "./FileUploadTemplate.vue?vue&type=template&id=34bf0bb6&"
import script from "./FileUploadTemplate.vue?vue&type=script&lang=js&"
export * from "./FileUploadTemplate.vue?vue&type=script&lang=js&"
import style0 from "./FileUploadTemplate.vue?vue&type=style&index=0&id=34bf0bb6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports